/**
 * `<pg-badge>` — rótulo curto de status/categoria.
 *
 * Atributo `tone`: 'neutro' (padrão) | 'sucesso' | 'alerta' | 'erro' | 'destaque'
 *
 * Uso:
 * ```html
 * <pg-badge tone="sucesso">Pago</pg-badge>
 * ```
 * O componente não sabe o que "Pago" significa — apenas exibe o texto
 * recebido via slot, colorido conforme o `tone`.
 */
export class PgBadge extends HTMLElement {
    static get observedAttributes() {
        return ['tone'];
    }
    root;
    constructor() {
        super();
        this.root = this.attachShadow({ mode: 'open' });
    }
    connectedCallback() {
        this.render();
    }
    attributeChangedCallback() {
        this.render();
    }
    render() {
        const tone = this.getAttribute('tone') ?? 'neutro';
        this.root.innerHTML = `
      <style>
        :host { display: inline-block; }
        span {
          display: inline-flex;
          align-items: center;
          font-family: var(--pg-font-familia-base, system-ui);
          font-size: var(--pg-font-size-xs, 0.75rem);
          font-weight: var(--pg-font-weight-semibold, 600);
          padding: 2px var(--pg-space-3, 12px);
          border-radius: var(--pg-radius-full, 9999px);
          border: var(--pg-border-largura, 1px) solid transparent;
          line-height: var(--pg-line-height-apertado, 1.2);
        }
        .neutro {
          background: var(--pg-color-bg-elevado, #1a1d21);
          color: var(--pg-color-texto-secundario, #9aa1ab);
          border-color: var(--pg-color-borda, #2a2f36);
        }
        .sucesso {
          background: rgba(59, 178, 115, 0.15);
          color: var(--pg-color-sucesso, #3bb273);
        }
        .alerta {
          background: rgba(224, 165, 44, 0.15);
          color: var(--pg-color-alerta, #e0a52c);
        }
        .erro {
          background: rgba(229, 72, 77, 0.15);
          color: var(--pg-color-erro, #e5484d);
        }
        .destaque {
          background: rgba(47, 140, 255, 0.15);
          color: var(--pg-color-destaque, #2f8cff);
        }
      </style>
      <span class="${tone}"><slot></slot></span>
    `;
    }
}
customElements.define('pg-badge', PgBadge);
//# sourceMappingURL=pg-badge.js.map